import React, {Component} from 'react';
import {connect} from 'react-redux';
import style from '../css/placedBets.css';
// helpers
import {getFormattedCurrency, getText, usingNonDecimalCurrency} from '../../../helpers/localization';
import {getModuleFromEventType} from '../../../helpers/moduleHelpers';
// constants
import {
    AMERICAN_FOOTBALL_MODULE,
    BASKETBALL_MODULE,
    FIRST_DOWN_MODULE,
    FOOTBALL_MODULE,
    MATCHDAY_MODULE,
    PLACED,
    RACING_MODULE,
    VPP_REAL_BET,
    CRICKET_MODULE,
    BASEBALL_MODULE, TENNIS, TENNIS_MODULE
} from '../../../constants/identifiers';
// components
import LockedBetFootball from '../modules/football/components/lockedBetFootball';
import LockedBetRacing from '../modules/racing/components/lockedBetRacing';
import LockedBetFirstDown from '../modules/firstDown/components/lockedBetFirstDown';
import LockedBetCricket from '../modules/cricket/components/lockedBetCricket';
import Accordion from '../components/accordion';
import {roundNumber} from '../../../helpers/mathFunctions';
import {BASE_VALUE} from '../../../constants/chips';
import {calculateEachWayValues} from '../../../helpers/eachWayBetHelpers';
import LockedBetBasketball from "../modules/basketball/components/lockedBetBasketball";
import LockedBetAmericanFootball from "../modules/americanFootball/components/lockedBetAmericanFootball";
import {collapsePlacedBetAccordion} from '../../../actions/betSlipActions';
import LockedBetMatchday from "../modules/matchday/components/lockedBetMatchday";
import {getPotentialReturn, getRoundedOdds} from '../modules/matchday/helpers/matchdayHelper';
import {getGameCategoryNameByChannel} from '../helpers/gameHelpers';
import {OPERATOR} from "../../../constants/operator";
import LockedBetTennis from '../modules/tennis/components/lockedBetTennis';
import LockedBetBaseBall from "../modules/baseball/components/lockedBetBaseball"
const mapStateToProps = (state, ownProps) => {
    return {
        placedBets: state.vpp.placedBets,
        collapsedPlacedBetAccordions: state.vpp.collapsedPlacedBetAccordions,
        systemLanguage:state.vpp.systemLanguage
    };
};

class PlacedBets extends Component {

    constructor(props) {
        super(props);

        let store = this.props.store;
        let storeData = store.getState();

        this.state = {
            placedBets: storeData.vpp.placedBets,
            collapsedPlacedBetAccordions: storeData.vpp.collapsedPlacedBetAccordions,
            systemLanguage: storeData.vpp.systemLanguage
        };

    }

    componentWillReceiveProps(nextProps) {
        let store = nextProps.store;
        let storeData = store.getState();

        if (nextProps && storeData) {
            this.setState({
                placedBets: storeData.vpp.placedBets,
                collapsedPlacedBetAccordions: storeData.vpp.collapsedPlacedBetAccordions,
                systemLanguage: storeData.vpp.systemLanguage
            });
        }
    }

    _toggleAccordion(gameCategory) {
        this.props.store.dispatch(collapsePlacedBetAccordion(gameCategory))
    }

    render() {
        let gameCategoriesPlacedBets;
        let isEmpty = true;
        let totalStake = 0;
        let totalPotentialReturns = 0;
        let gameCategories;
        if (this.props.store.getState().vpp.games !== undefined && this.state.placedBets.length > 0) {
            let placedBetsFiltered = this.state.placedBets;
            placedBetsFiltered.sort((a,b)=>a.Bets[0].EventTime - b.Bets[0].EventTime);
            gameCategories = [...new Set(placedBetsFiltered.map(betSelection => getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel)))];
            gameCategoriesPlacedBets = gameCategories.map((gameCategory, gameIndex) => {
                let eventsOfGivenCategory = placedBetsFiltered.filter((betSelection) => gameCategory === getGameCategoryNameByChannel(this.props.store, betSelection.Bets[0].Channel));
                eventsOfGivenCategory.sort((a, b) => a.Bets[0].EventTime - b.Bets[0].EventTime);
                if (eventsOfGivenCategory !== undefined && eventsOfGivenCategory.length !== 0 && getModuleFromEventType(eventsOfGivenCategory[0].Bets[0].EventType) === MATCHDAY_MODULE) {
                    eventsOfGivenCategory.sort(function (a, b) {
                        if (a.Bets.length > b.Bets.length) return 1;
                        if (a.Bets.length < b.Bets.length) return -1;
                        if (a.Bets[0].EventTime > b.Bets[0].EventTime) return 1;
                        if (a.Bets[0].EventTime < b.Bets[0].EventTime) return -1;
                        if (a.Bets[0].LastUpdatedDate > b.Bets[0].LastUpdatedDate) return 1;
                        if (a.Bets[0].LastUpdatedDate < b.Bets[0].LastUpdatedDate) return -1;
                    });
                }
                return eventsOfGivenCategory.map((betSelection, betSelectionIndex) => {
                    isEmpty = false;
                    let placedBetCard = null;
                    let module = getModuleFromEventType(betSelection.Bets[0].EventType);
                    let stake;

                    // special case for EW bets (potential return is 1/4 of win prize)
                    if (module === RACING_MODULE && betSelection.Bets[0].ExternalRefId !== undefined) {
                        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                            stake = betSelection.Bets[0].Stake / 2;
                        } else {
                            stake = roundNumber((betSelection.Bets[0].Stake / 2) / BASE_VALUE, 2);
                        }
                        let marketInfo = betSelection.Bets[0].OpaqueData === undefined ? null : JSON.parse(betSelection.Bets[0].OpaqueData);
                        let ewValues = calculateEachWayValues(stake, betSelection.Bets[0].Market.Price, marketInfo.eachWayRatio);

                        totalStake += ewValues.totalStake;
                        totalPotentialReturns += ewValues.potentialReturns;
                        if (OPERATOR.promoToolEnabled && !(betSelection.PromoId === VPP_REAL_BET))
                                        totalPotentialReturns = totalPotentialReturns ;

                        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                            totalPotentialReturns = Math.round(totalPotentialReturns);
                            if (OPERATOR.promoToolEnabled && !(betSelection.PromoId === VPP_REAL_BET))
                                        totalPotentialReturns = totalPotentialReturns ;
                        }
                    } else if (betSelection.Bets.length == 1 && Number(betSelection.Bets[0].Stake)) { // normal use case
                        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                            stake = betSelection.Bets[0].Stake;
                        } else {
                            stake = Number(roundNumber(betSelection.Bets[0].Stake / BASE_VALUE, 2));
                        }
                        totalStake += stake;
                        let potentialReturns = getPotentialReturn(betSelection.Bets[0].Market.Price, stake, 1, 0);
                        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                            potentialReturns = roundNumber(potentialReturns, 0);
                        }
                        totalPotentialReturns += potentialReturns;
                        if (OPERATOR.promoToolEnabled && !(betSelection.PromoId === VPP_REAL_BET))
                                        totalPotentialReturns = totalPotentialReturns - Number(roundNumber(betSelection.Bets[0].Stake / BASE_VALUE, 2));
                    } else if (betSelection.Bets.length > 1 && Number(betSelection.Bets[0].Stake)) {
                        if (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) {
                            stake = Number(betSelection.Bets[0].Stake);
                        } else {
                            stake = Number(roundNumber(betSelection.Bets[0].Stake / BASE_VALUE, 2));
                        }
                        totalStake += stake;
                        let odds, currentStake, multiplier;
                        multiplier = Number(betSelection.multiplier ? betSelection.multiplier : 1);
                        currentStake = ((betSelection.Bets[0].Stake * BASE_VALUE) / multiplier) / BASE_VALUE;
                        odds = getRoundedOdds(betSelection.Bets, false);
                        totalPotentialReturns += (usingNonDecimalCurrency(this.props.store.getState().vpp.systemCurrency)) ? getPotentialReturn(odds, currentStake, multiplier, betSelection.Bonus) : getPotentialReturn(odds, currentStake / BASE_VALUE, multiplier, betSelection.Bonus);
                        if (OPERATOR.promoToolEnabled && !(betSelection.PromoId === VPP_REAL_BET))
                                        totalPotentialReturns = totalPotentialReturns - Number(roundNumber(betSelection.Bets[0].Stake / BASE_VALUE, 2));
                    }

                    if (betSelection.Bets[0].EventType !== undefined) {
                        switch (module) {
                            case RACING_MODULE:
                                placedBetCard = (
                                    <LockedBetRacing key={gameIndex + betSelectionIndex}
                                                     index={gameIndex + '_' + betSelectionIndex}
                                                     store={this.props.store} betSelection={betSelection}
                                                     betsType={PLACED}/>);
                                break;
                            case FOOTBALL_MODULE:
                                placedBetCard = (
                                    <LockedBetFootball key={gameIndex + betSelectionIndex}
                                                       index={gameIndex + betSelectionIndex}
                                                       store={this.props.store} betSelection={betSelection}
                                                       betsType={PLACED}/>);
                                break;
                            case BASKETBALL_MODULE:
                                placedBetCard = (
                                    <LockedBetBasketball key={gameIndex + betSelectionIndex}
                                                         index={gameIndex + betSelectionIndex}
                                                         store={this.props.store} betSelection={betSelection}
                                                         betsType={PLACED}/>);
                                break;
                            case AMERICAN_FOOTBALL_MODULE:
                                placedBetCard = (
                                    <LockedBetAmericanFootball key={gameIndex + betSelectionIndex}
                                                               index={gameIndex + betSelectionIndex}
                                                               store={this.props.store} betSelection={betSelection}
                                                               betsType={PLACED}/>);
                                break;
                            case FIRST_DOWN_MODULE:
                                placedBetCard = (
                                    <LockedBetFirstDown key={gameIndex + betSelectionIndex}
                                                        index={gameIndex + betSelectionIndex}
                                                        store={this.props.store} betSelection={betSelection}
                                                       betsType={PLACED}/>);
                                break;
                            case MATCHDAY_MODULE:
                                placedBetCard = (<LockedBetMatchday key={gameIndex + betSelectionIndex}
                                                                    index={gameIndex + betSelectionIndex}
                                                                    store={this.props.store} isSettledBet={false}
                                                                    betSelection={betSelection} betsType={PLACED}/>);
                                break;
                            //PROD_VSB-5349_ open_bet_slip
                            case CRICKET_MODULE:
                                placedBetCard = (<LockedBetCricket key={gameIndex + betSelection}
                                                                    index={gameIndex + betSelectionIndex}
                                                                    store = {this.props.store} isSettledBet={false}
                                                                    betSelection = {betSelection} betsType={PLACED}/>);
                                break;
                            case TENNIS_MODULE:
                                placedBetCard = (<LockedBetTennis key={gameIndex + betSelection}
                                                                   index={gameIndex + betSelectionIndex}
                                                                   store = {this.props.store} isSettledBet={false}
                                                                   betSelection = {betSelection} betsType={PLACED}/>);
                                break;
                            case BASEBALL_MODULE:
                                    placedBetCard = (<LockedBetBaseBall key={gameIndex + betSelection} game={"baseball"}
                                                                        index={gameIndex + betSelectionIndex}
                                                                        store = {this.props.store} isSettledBet={false}
                                                                        betSelection = {betSelection} betsType={PLACED}/>);
                                    break;
                            default:
                                placedBetCard = (<div key={gameIndex + betSelectionIndex}/>);
                                break;
                        }
                    }

                    return placedBetCard;
                });
            });
        }

        let gameCategoriesPlacedBetsUI;
        if (isEmpty) {
            gameCategoriesPlacedBetsUI = (
                <div className={style.noBetsText}>{getText('NO_BETS', this.props.store)}</div>);
        } else {
            gameCategoriesPlacedBetsUI = gameCategoriesPlacedBets.map((gameCategoryPlacedBets, index) => {
                if (gameCategoryPlacedBets.length > 0) {
                    let isExpanded = !this.state.collapsedPlacedBetAccordions.find((gameCategory) => gameCategory === gameCategories[index])
                    let content = <div>{gameCategoryPlacedBets}</div>;
                    return <Accordion key={index} id={'game_accordion_' + index}
                                      store={this.props.store}
                                      content={content}
                                      onClick={this._toggleAccordion.bind(this)}
                                      isExpanded={isExpanded}
                                      label={getText('betSlip_' + gameCategories[index], this.props.store)}
                                      collapseKey={gameCategories[index]}/>;
                }
                return null;
            });
        }

        // format stake totals to the right currency
        let systemCurrency = this.props.store.getState().vpp.systemCurrency;

        if (usingNonDecimalCurrency(systemCurrency)) {
            totalStake = getFormattedCurrency(this.props.store, "" + totalStake);
            totalPotentialReturns = Math.round(totalPotentialReturns);
            totalPotentialReturns = getFormattedCurrency(
                this.props.store,
                "" + totalPotentialReturns
            );
        } else {
            totalStake = getFormattedCurrency(this.props.store, totalStake);
            totalPotentialReturns = getFormattedCurrency(
                this.props.store,
                totalPotentialReturns
            );
        }
       // totalStake = getFormattedCurrency(this.props.store, totalStake);
        // totalPotentialReturns = getFormattedCurrency(this.props.store, totalPotentialReturns);

        let betConfirmedText = null;
        let betsList = [];
        if(this.state.placedBets.length > 0) {
            betsList = this.state.placedBets.filter((bet) => !bet.messageDisplayed);
            let BET_CONFIRMED_TEXT=getText('BET_CONFIRMED_TEXT', this.props.store);
            let styleName = betsList.length > 0? style.placedBetsBetConfirmedText:style.placedBetsBetConfirmedTextNoAnimation;
            betConfirmedText=BET_CONFIRMED_TEXT!='none'?(<div id={'place_bets_message'} className={styleName}>
                    {BET_CONFIRMED_TEXT}</div>):'';
            this.state.placedBets = this.state.placedBets.map((cBet) => {
                cBet.messageDisplayed = true;
                return cBet;
            });
        }

        let TAX_NOTIFICATION_TEXT = getText('TAX_NOTIFICATION_TEXT', this.props.store);

        let taxNotification = TAX_NOTIFICATION_TEXT != 'none' ? (
            <div className={style.taxNotification}>{TAX_NOTIFICATION_TEXT}</div>
        ) : '';

        return (<div className={style.mainContainer}>
            <div className={`${style.placedBetsAccordions} ${TAX_NOTIFICATION_TEXT != 'none'
                ? style.placedBetsAccordionsWithTaxText
                : ''}`}>
                {gameCategoriesPlacedBetsUI}
            </div>
            {betConfirmedText}
            {taxNotification}
            <div className={style.bottomContainer}>
                <div className={style.infoContainer}>
                    <div className={style.totalStakeContainer}>
                        <div className={style.totalStakeText}>{getText('TOTAL_STAKE', this.props.store)}</div>
                        <div id={'total_stake_value'} className={style.totalStakeValue}>{totalStake.toString()}</div>
                    </div>
                    <div className={style.totalReturnsContainer}>
                        <div
                            className={style.totalReturnsText}>{getText('TOTAL_POTENTIAL_RETURNS', this.props.store)}</div>
                        <div id={'total_returns_value'}
                             className={style.totalReturnsValue}>{totalPotentialReturns.toString()}</div>
                    </div>
                </div>
                <div className={style.buttonsContainer}>
                </div>
            </div>
        </div>);
    }

}

export default connect(mapStateToProps)(PlacedBets);



// WEBPACK FOOTER //
// ./src/ui-modules/sports-book/containers/placedBets.js